import { render } from "./BottomListAvatarProp.vue?vue&type=template&id=dd5c822a&scoped=true"
import script from "./BottomListAvatarProp.vue?vue&type=script&lang=js"
export * from "./BottomListAvatarProp.vue?vue&type=script&lang=js"

import "./BottomListAvatarProp.vue?vue&type=style&index=0&id=dd5c822a&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5c822a"]])

export default __exports__